import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  appBar: {
    ...theme.typography.specialGradient,
    zIndex: theme.zIndex.drawer + 1
  },
  title: {
    color: 'white',
    letterSpacing: '0.2em',
    fontWeight: 700
  },
  primaryText: {
    color: theme.palette.primary.main
  },
  tabs: {
    marginLeft: 'auto'
  },
  tab: {
    color: 'white',
    '&.MuiTab-root': {
      minWidth: '100px'
    }
  },
  buttonLogin: {
    marginLeft: theme.spacing(1),
    fontWeight: 700,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  buttonLogout: {
    marginLeft: theme.spacing(1),
    fontWeight: 700,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.light
    }
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  list: {
    width: 250
  },
  enter: {
    backgroundColor: theme.palette.success.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    }
  },
  logout: {
    backgroundColor: theme.palette.error.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    }
  },
  listItem: {
    '&.Mui-selected': {
      backgroundColor: theme.palette.common.black
    }
  },
  avatar: {
    width: 64,
    height: 64,
    backgroundColor: theme.palette.primary.main
  }
}))